import { BonusSettlementCustomerStatus } from '@synergy/models';
import { PaginatedResponse } from '@synergy/api';
import { createReducer } from '@reduxjs/toolkit';

import {
    BonusSettlementCustomer,
    BonusSettlementCustomerOverviewDetail,
} from '../../models/bonus-settlement-customer-overview';
import {
    completeCustomers,
    fetchBonusSettlementsCustomerOverview,
    fetchBonusSettlementsCustomerOverviewDetails,
    reloadCustomers,
    reopenCustomer,
    resetBonusSettlementsCustomerOverviewState,
} from './bonus-settlements-customer-overview-actions';

export interface BonusSettlementCustomerOverviewReducerState {
    bonusSettlementsCustomerOverview: PaginatedResponse<BonusSettlementCustomer>;
    details?: BonusSettlementCustomerOverviewDetail;
    requesting: boolean;
}

export const initialBonusSettlementsCustomerOverviewReducerState: BonusSettlementCustomerOverviewReducerState = {
    bonusSettlementsCustomerOverview: { items: [], total: 0, limit: 10, page: 0 },
    details: undefined,
    requesting: false,
};

export const bonusSettlementsCustomerOverviewReducer = createReducer(
    initialBonusSettlementsCustomerOverviewReducerState,

    builder =>
        builder
            .addCase(fetchBonusSettlementsCustomerOverview.pending, state => {
                state.requesting = true;
            })
            .addCase(fetchBonusSettlementsCustomerOverview.fulfilled, (state, action) => {
                state.bonusSettlementsCustomerOverview = action.payload;
                state.requesting = false;
            })
            .addCase(fetchBonusSettlementsCustomerOverview.rejected, state => {
                state.requesting = false;
            })
            .addCase(fetchBonusSettlementsCustomerOverviewDetails.fulfilled, (state, action) => {
                state.details = action.payload;
            })
            .addCase(reloadCustomers.pending, state => {
                state.requesting = true;
            })
            .addCase(reloadCustomers.fulfilled, state => {
                state.requesting = false;
            })
            .addCase(reloadCustomers.rejected, state => {
                state.requesting = false;
            })
            .addCase(resetBonusSettlementsCustomerOverviewState, state => {
                state.bonusSettlementsCustomerOverview =
                    initialBonusSettlementsCustomerOverviewReducerState.bonusSettlementsCustomerOverview;
            })
            .addCase(completeCustomers.fulfilled, (state, action) => {
                const completedItems = state.bonusSettlementsCustomerOverview.items.map(item => {
                    if (action.payload.completeAll || (action.payload.customerIds ?? []).includes(item.id)) {
                        return { ...item, status: BonusSettlementCustomerStatus.Completed };
                    }
                    return item;
                });

                state.bonusSettlementsCustomerOverview.items = completedItems;
            })
            .addCase(reopenCustomer.fulfilled, (state, action) => {
                const tempItems = state.bonusSettlementsCustomerOverview.items.map(item => {
                    if (action.payload === item.customerId) {
                        return { ...item, status: BonusSettlementCustomerStatus.ReadyToComplete };
                    }

                    return item;
                });

                state.bonusSettlementsCustomerOverview.items = tempItems;
            })
);
